import { defaultBundle, StoreConfig } from './store-config';
let sharedConfig = new StoreConfig();
sharedConfig.setConfig({
    bundle: {
        name: defaultBundle,
        paths: ['/'],
    },
});
if (typeof window !== 'undefined' && !window.storeConfig) {
    window.storeConfig = sharedConfig;
}
/**
 * Возвращает экземляр {@link StoreConfig}
 * @return {StoreConfig}
 */
export function getSharedConfig() {
    if (typeof window !== 'undefined') {
        return window.storeConfig;
    }
    return sharedConfig;
}
/**
 * Устанавливает экземпляр {@link StoreConfig}
 * @param {StoreConfig} storeConfig
 */
export function setSharedConfig(storeConfig) {
    if (typeof window !== 'undefined') {
        return (window.storeConfig = storeConfig);
    }
    sharedConfig = storeConfig;
}
